import React from "react";
import moment from "moment";
import Select from "react-select";

import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import styles from "./style.module.css";

export default class DatasetRow extends React.PureComponent {
  render() {
    const { dataset, onClick, isHighlight, onHover, history } = this.props;

    return (
      <TableRow
        isHighlight={isHighlight}
        onMouseEnter={onHover ? () => onHover(dataset.id) : () => {}}
        onMouseLeave={onHover ? () => onHover(undefined) : () => {}}
      >
        <TableColumn>
          <a onClick={() => onClick()}>{dataset.label}</a>
        </TableColumn>
        <TableColumn title={moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}>
          {moment.utc(dataset.created).local().fromNow()}
        </TableColumn>
        <TableColumn>{dataset.outcome}</TableColumn>
        <TableColumn>{Object.keys(dataset.fields).length}</TableColumn>
        <TableColumn>{dataset.rowCount}</TableColumn>
        <TableColumn>
          <div className={styles.capitalize}>{dataset.status}</div>
        </TableColumn>
        <TableColumn>{dataset.warnings.length}</TableColumn>
      </TableRow>
    );
  }
}
